import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ArticleSummary } from '../_models';

export interface CancelInstallationPayload {
  target_warehouse_id: number;
  target_storage_bin_id: number;
  bad_part?: boolean;
  bad_part_description?: string;
}

@Injectable({ providedIn: 'root' })
export class TicketArticleHandlingService {
  constructor(private http: HttpClient) {}

  /**
   * Storniert eine einzelne installierte Material-Buchung. Backend bucht den
   * Artikel zurueck ins gewaehlte Lager + Bin, optional als Bad Part, und
   * liefert das aktualisierte article_summary zurueck.
   */
  cancelInstallation(
    ticketId: number,
    handlingId: number,
    payload: CancelInstallationPayload,
  ): Observable<ArticleSummary> {
    return this.http.request<ArticleSummary>(
      'DELETE',
      `${environment.apiURL}tickets/${ticketId}/article_handlings/${handlingId}.json`,
      { body: payload, withCredentials: true },
    );
  }
}
